import { Token } from 'config/types'
import { ChainIdEnum } from '../network'

const path = '/images/token'

const tokens: Record<string, Token> = {
  TRX: {
    coinGeckoInfo: {
      id: 'tron',
    },
    logo: `${path}/trx.png`,
    name: 'TRX',
    code: 'TRX',
    network: ChainIdEnum.TRX,
    isNative: true,
    decimals: 6,
  },
  USDT: {
    coinGeckoInfo: {
      id: 'tether',
    },
    logo: `${path}/usdt.png`,
    name: 'USDT',
    code: 'USDT',
    network: ChainIdEnum.TRX,
    address: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
    decimals: 6,
    isStable: true,
  },
}

export default tokens
